module.exports = __webpack_public_path__ + "static/media/MemoryGame.59498cfe.png";